function getQueryVariable(variable) {
  const queryParams = window.location.search.substring(1);
  const queryParamsList = queryParams.split('&');

  for (let i = 0; i < queryParamsList.length; i += 1) {
    const queryPair = queryParamsList[i].split('=');

    if (queryPair[0] === variable) {
      return queryPair[1];
    }
  }

  return null;
}

function createCookie(name, value, days) {
  let expires = '';

  if (days) {
    const date = new Date();

    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=${date.toGMTString()}`;
  }
  document.cookie = `${name}=${value}${expires}; path=/`;
}

function readCookie(name) {
  const nameEQ = `${name}=`;
  const ca = document.cookie.split(';');

  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i];

    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function filterInputsByParam(input, param) {
  return input.classList.contains(param) || input.name === param;
}

function setInputValue(inputs, val) {
  inputs.forEach((input) => {
    input.value = val;
  });
}

const cookieName = '_aaa_utmz';

document.addEventListener('DOMContentLoaded', () => {
  const utmSourceInputs = Array.from(document.querySelectorAll('input')).filter(
    (utmSourceInput) => filterInputsByParam(utmSourceInput, 'utm_source')
  );
  const utmSourceVal = getQueryVariable('utm_source');

  if (utmSourceVal) {
    setInputValue(utmSourceInputs, utmSourceVal);
  }

  const utmMediumInputs = Array.from(document.querySelectorAll('input')).filter(
    (utmSourceInput) => filterInputsByParam(utmSourceInput, 'utm_medium')
  );
  const utmMediumVal = getQueryVariable('utm_medium');

  if (utmMediumVal) {
    setInputValue(utmMediumInputs, utmMediumVal);
  }

  const utmCampaignInputs = Array.from(
    document.querySelectorAll('input')
  ).filter((utmSourceInput) =>
    filterInputsByParam(utmSourceInput, 'utm_campaign')
  );
  const utmCampaignVal = getQueryVariable('utm_campaign');

  if (utmCampaignVal) {
    setInputValue(utmCampaignInputs, utmCampaignVal);
  }

  const utmTermInputs = Array.from(document.querySelectorAll('input')).filter(
    (utmSourceInput) => filterInputsByParam(utmSourceInput, 'utm_term')
  );
  const utmTermVal = getQueryVariable('utm_term');

  if (utmTermVal) {
    setInputValue(utmTermInputs, utmTermVal);
  }

  const utmContentInputs = Array.from(
    document.querySelectorAll('input')
  ).filter((utmSourceInput) =>
    filterInputsByParam(utmSourceInput, 'utm_content')
  );
  const utmContentVal = getQueryVariable('utm_content');

  if (utmContentVal) {
    setInputValue(utmContentInputs, utmContentVal);
  }

  if (getQueryVariable('utm_source')) {
    createCookie(
      cookieName,
      `${getQueryVariable('utm_source')}|${getQueryVariable(
        'utm_medium'
      )}|${getQueryVariable('utm_term')}|${getQueryVariable(
        'utm_campaign'
      )}|${getQueryVariable('utm_content')}`,
      60
    );
  } else if (readCookie(cookieName)) {
    const utmCookie = readCookie(cookieName);

    const utmCookies = utmCookie.split('|');

    setInputValue(utmSourceInputs, utmCookies[0]);
    setInputValue(utmMediumInputs, utmCookies[1]);
    setInputValue(utmTermInputs, utmCookies[2]);
    setInputValue(utmCampaignInputs, utmCookies[3]);
    setInputValue(utmContentInputs, utmCookies[4]);
  }
});
